/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Ingest_Approval_Item_CountInputs */

const es_components_ingest_approval_item_count = /** @type {(inputs: Components_Ingest_Approval_Item_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} elemento(s) seleccionado(s)`)
};

const en_components_ingest_approval_item_count = /** @type {(inputs: Components_Ingest_Approval_Item_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} item(s) selected`)
};

/**
* | output |
* | --- |
* | "{count} item(s) selected" |
*
* @param {Components_Ingest_Approval_Item_CountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ingest_approval_item_count = /** @type {((inputs: Components_Ingest_Approval_Item_CountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ingest_Approval_Item_CountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ingest_approval_item_count(inputs)
	return en_components_ingest_approval_item_count(inputs)
});
export { components_ingest_approval_item_count as "components.ingest_approval.item_count" }